/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Snackbar, Divider } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { CollectionView } from "@grapecity/wijmo";

import uiConf from "../../config/uiConf";

import apiClient from "../../lib/common/apiClient";
import getSchema from "../../lib/api/getSchema";

import Dialog from "../dialog/functional/Dialog";
import DialogHeader from "../dialog/functional/DialogHeader";
import DialogContent from "../dialog/functional/DialogContent";
import DialogTitle from "../dialog/functional/DialogTitle";
import DialogActionsOkCancel from "../dialog/functional/DialogActionsOkCancel";
import BasicStaticGridScreenType from "../screenTypes/functional/BasicStaticGridScreenType";

function AddProcessPlanDialog ( props ) {

    const { t } = useTranslation ();

    const [instance, setInstance] = useState ();

    // const [processes, setProcesses] = useState ([]);
    const [schema, setSchema] = useState ();    
    const [collectionView, setCollectionView] = useState ();
    
    const [, setGrid] = useState ();
    const [, setTask] = useState ();

    const [actionButtonsDisabled, setActionButtonsDisabled] = useState ([true, false]);

    const [notification, setNotification] = useState({
        open: false,
        severity: "success",
        msg: "",
    });

    const {

        id,
        
        task,
        processes,

        moveable,
        resizable,
        fullWidth,
        maxWidth,

        onClose,
        onInitialized,
        onSuccess,

        ...others

    } = props;

    const checkActionButtonDisabled = () => {

        setGrid ( ( grid ) => {

            let processCount = 0;
            for ( let row of grid.rows ) {

                if ( row.dataItem.produce ) {

                    processCount++;

                }

            }

            let disabled = processCount < 1;

            setActionButtonsDisabled ( [disabled, false] );

            return grid;

        } );

    };

    useEffect ( () => {

        let mounted = true;

        ( async () => {
        
            let schema = await getSchema("TkVwProcessNotPlanned");

            for (const column of schema.columns) {

                switch (column.name) {

                    case "produce":

                        column.onChange = ( ctx, produce ) => {
                            
                            setGrid ( ( grid ) => {

                                ctx.item.produce = produce ? true : false;

                                if ( !ctx.item.produce ) {

                                    ctx.item.outSourcing = false;

                                }

                                grid.refresh (false);

                                setTimeout ( checkActionButtonDisabled, 0 );

                                return grid;

                            } );

                        };

                        break;

                    case "outSourcing":

                        column.onChange = ( ctx, outSourcing ) => {

                            setGrid ( ( grid ) => {

                                ctx.item.outSourcing = outSourcing ? 1 : 0;
                                grid.refresh (false);

                                setTimeout ( checkActionButtonDisabled, 0 );

                                return grid;

                            } );

                        };

                        break;

                    default:

                        break;
                        
                }

            }


            if ( mounted ) {

                setSchema ( schema )

            }
        
        } ) ();

        return ( () => {

            mounted = false;

        } );

    }, [] );

    useEffect ( () => {

        /*
        if ( task ) {

            ( async () => {

                let result = await getList ( `TkVwProcessNotPlanned/${task.id}` );
                let processes = result.data;

                setProcesses ( processes );
    
            } ) ();

        } else {

            setProcesses ( [] );

        }
        */
    
        setTask ( task );

    }, [task] );

    useEffect ( () => {

        let collectionView = new CollectionView ( processes )

        setCollectionView ( collectionView );                                        

        let processCount = 0;

        for ( let process of processes ) {

            if ( process.produce ) {

                processCount++;

            }

        }

        let disabled = processCount < 1;

        setActionButtonsDisabled ( [disabled, false] );

    }, [processes]);

    const notifyFailure = (msg) => {

        console.error ( msg );

        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });

    };

    const onDialogInitialized = ( instance ) => {

        setInstance(instance);

        if ( onInitialized ) {

            onInitialized ( instance );

        }

    };

    const onGridInitialized = ( grid ) => {

        setGrid ( grid );

        if ( grid ) {

            grid.selectionMode = "None";
    
        }

    };

    const onApiSuccess = ( result, taskId, processCode, processName ) => {

        setInstance ( ( instance ) => {

            if ( instance ) {

                instance.hide();

            }

            return instance;

        } );

        if ( onSuccess ) {

            onSuccess ( t ( "success.addProcessSuccess" ) );

        }

        setInstance ( ( instance ) => {

            if ( instance ) {

                instance.hide();

            }

            return instance;

        } );

    };

    const onApiFailure = ( apiData, reason ) => {

        console.error ( apiData );
        notifyFailure ( t ( "error.addProcessFailed" ) + ` : ${ reason.response ? reason.response.data : JSON.stringify ( reason ) }` );

    };

    const onOk = () => {                            

        setTask ( ( task ) => {

            setGrid ( ( grid ) => {

                let planId = task.id;

                let processes = [];

                for ( let row of grid.rows ) {

                    let process = row.dataItem;

                    if ( process.produce ) {

                        processes.push ( {
                            processCode: process.processCode,
                            processName: process.processName,
                            outSourcing: process.outSourcing
                        } );
    
                    }

                }
                        
                let apiData = processes;
                    
                let form = new FormData ();
                let json = apiData;
                let deleted = {};
    
                form.append ( "deleted", JSON.stringify ( deleted ) );
                form.append ( "json", JSON.stringify ( json ) );
                
                apiClient
                    .post(`/api/TkPlan/${planId}/process`, form, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then((result) => onApiSuccess(result))
                    .catch((reason) => onApiFailure(apiData, reason));
    
                return grid;
                
            } );
    
            return task;

        } );

    }

    const onCancel = () => {

        instance.hide ();

    };


    const onCloseNotification = () => {

        setNotification ( ( notification ) => {

            return ( {...notification, open: false} );

        } );

    };

    const onCloseDialog = () => {
        
        if ( onClose ) {

            onClose ();

        }
 
    };

    return (

        <Dialog
            id={id}
            moveable={moveable ? moveable : uiConf.dialogMoveable}
            resizable={resizable ? resizable : uiConf.dialogResizable}
            fullWidth={fullWidth ? fullWidth : uiConf.dialogFullWidth}
            maxWidth="sm"
            onClose={onCloseDialog}
            onInitialized={onDialogInitialized}
            {...others}
        >

            <DialogHeader>
                <DialogTitle>
                    { t ( "dialog.title.ProductionPlan.addProcess", { taskName: task?.taskName } ) }
                </DialogTitle>
            </DialogHeader>

            <Divider />

            <DialogContent style={{padding: "0px", height: "400px"}}>

                <BasicStaticGridScreenType                        
                    id="machines-grid"
                    embededInOtherScreenType
                    headerTitle={t("term.machine")}
                    headerTitleStyle={{
                        fontSize: "16px",
                        fontWeight: "bold",
                        marginLeft: "8px",
                        marginTop: "8px",
                    }}
                    allowSorting={0}
                    schema={schema}
                    itemsSource={collectionView}
                    onInitialized={onGridInitialized}
                />


                <Snackbar
                    open={notification.open && notification.severity !== "success"}
                    autoHideDuration={uiConf.dialogNotifyAutoHideDuration}
                    onClose={onCloseNotification}
                >

                    <Alert
                        onClose={onCloseNotification}
                        variant="filled"
                        severity={notification.severity}
                    >

                        {notification.msg}

                    </Alert>

                </Snackbar>

            </DialogContent>

            <Divider />

            <DialogActionsOkCancel
                buttonDisabled={ actionButtonsDisabled }
                onOk={() => onOk()}
                onCancel={onCancel}
            />

        </Dialog>

    );

}

export default AddProcessPlanDialog;
